import React, { useState, useEffect } from 'react';
import { AiOutlineBell } from 'react-icons/ai';
import { FiCheck } from 'react-icons/fi';
import { requestNotificationPermission } from '../../firebase/config';
import myAxios from '../AxiosUrl';
import styles from './PushNotificationModal.module.css';

function PushNotificationModal() {
    const [showModal, setShowModal] = useState(false);
    const [isDenied, setIsDenied] = useState(false);

    useEffect(() => {
        // Check if notifications are supported
        if (!('Notification' in window)) return;

        // If already granted, don't show
        if (Notification.permission === 'granted') return;

        // If denied by browser, show with denied message
        if (Notification.permission === 'denied') {
            setIsDenied(true);
            setShowModal(true);
            return;
        }

        // Permission is 'default' - show modal after short delay
        const timer = setTimeout(() => {
            setShowModal(true);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    const handleAllow = async () => {
        try {
            const token = await requestNotificationPermission();
            if (token) {
                // Save token to backend
                const uid = localStorage.getItem('id');
                if (uid) {
                    await myAxios.post('/save-fcm-token', {
                        uid,
                        fcmToken: token,
                        deviceType: 'web',
                        timestamp: new Date().toISOString()
                    });
                }
                setShowModal(false);
            } else {
                // User denied in browser prompt
                setIsDenied(true);
            }
        } catch (error) {
            console.error('Error requesting notification permission:', error);
        }
    };

    const handleLater = () => {
        setShowModal(false);
    };

    if (!showModal) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.iconWrapper}>
                    <AiOutlineBell className={styles.bellIcon} />
                </div>
                <h2 className={styles.title}>Enable Notifications</h2>
                <p className={styles.description}>
                    Stay updated with real-time alerts for your store
                </p>
                <div className={styles.features}>
                    <div className={styles.feature}>
                        <span className={styles.featureIcon}><FiCheck /></span>
                        New order alerts
                    </div>
                    <div className={styles.feature}>
                        <span className={styles.featureIcon}><FiCheck /></span>
                        Payment & delivery updates
                    </div>
                    <div className={styles.feature}>
                        <span className={styles.featureIcon}><FiCheck /></span>
                        Low inventory warnings
                    </div>
                </div>
                {isDenied ? (
                    <div className={styles.deniedMessage}>
                        Notifications are blocked. Please enable them in your browser
                        settings: click the lock icon in the address bar → Site
                        settings → Notifications → Allow
                    </div>
                ) : (
                    <div className={styles.buttons}>
                        <button className={styles.laterBtn} onClick={handleLater}>
                            Later
                        </button>
                        <button className={styles.allowBtn} onClick={handleAllow}>
                            Allow Notifications
                        </button>
                    </div>
                )}
                {isDenied && (
                    <div className={styles.buttons} style={{ marginTop: 16 }}>
                        <button className={styles.laterBtn} onClick={handleLater}>
                            Close
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default PushNotificationModal;
